import { useEffect, useState } from "react";
import useReload from "./useReload";

const useProduct = () => {
    const [products, setProducts] = useState([])
    const [isReload, setIsReload] = useReload();
    useEffect(() => {
        fetch('https://warehouse-management-server-30mo.onrender.com/product')
            .then(res => res.json())
            .then(data => setProducts(data))
    }, [isReload])
    return [products, setProducts]
}
export default useProduct;